<template>
  <div class="menu-links">
    <v-menu
      content-class="main-menu"
      md-size="big"
      md-align-trigger
      :mdCloseOnClick="true"
      :mdCloseOnSelect="true"
      transition="slide-x-transition"
      :top="true"
      attach="#menuContainer"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="menu-activator-icon mobile" v-on="on">
          <font-awesome-icon class="menu-bars" v-on="on" :icon="['fas', 'bars']" />
        </div>
      </template>

      <div class="menu-layout">
        <div class="menu-items">
          <font-awesome-icon class="menu-close" v-on="on" :icon="['fas', 'times']" />
          <button
            v-for="link in links"
            :key="link.label"
            :class="{ active: isCurrentRoute(link) }"
            @click="onClickLink(link)"
            class="menu-item"
          >
            <span>{{ link.label }}</span>
          </button>
        </div>

        <div v-if="footer" class="menu-footer">
          <div class="contact-us">
            <p
              style="font-size: 0.8rem"
              v-translate="{ orgSupportEmail: organizationDetails.supportEmail }"
            >
              Reach out to %{orgSupportEmail} with any questions, issues, or feedback.
            </p>
          </div>
        </div>
      </div>
    </v-menu>

    <div class="hidden-mobile frow">
      <button
        v-for="link in links"
        :key="link.label"
        :class="{
          active: isCurrentRoute(link),
          mobile: link.label == 'LOG OUT' || link.label == 'CERRAR SESIÓN',
        }"
        @click="onClickLink(link)"
        class="menu-item"
        :data-action="link.actionName"
      >
        <span>{{ link.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MenuLinks',
  props: {
    links: {
      required: true,
    },
    footer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      on: false
    }
  },
  methods: {
    onClickLink(link) {
      if (link.googleAnalytics) {
        trackEvent(link.googleAnalytics.action, '', 'Menu', '')
      }

      if ('action' in link) {
        link.action()
      } else {
        // If router throws an error because of a route guard redirection, just log it
        this.$router.push({ name: link.route.name }).catch(error => console.log(error.message))
      }
    },
    isCurrentRoute(link) {
      if(!link.route)
        return false
      return this.$route.name == link.route.name
    },
  },
  computed: {
    ...mapState(['organizationDetails']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/flex-box';
@import '@/styles/mixins/responsive';

.menu-items {
  margin-left: 1.5rem;

  @include tablet-and-up-screen {
    display: flex;
    flex-direction: row;
    text-transform: capitalize;
  }
}

.menu-item {
  display: block;
  margin-bottom: 2rem;
  padding-bottom: 6px;
  cursor: pointer;
  border-bottom: 2px solid transparent;

  &.active,
  &:hover {
    border-bottom: 2px solid var(--dark-brand-color);
  }

  @include tablet-screen {
    margin: 0 0.5rem;
    padding: 6px 0.25rem 6px 0.25rem;
  }

  @include desktop-screen {
    margin: 0 1rem;
    padding: 6px 0.25rem 6px 0.25rem;
  }
}

.menu-bars {
  font-size: 1.5rem;
}

.menu-close {
  margin-top: 1rem;
  margin-bottom: 2rem;
  cursor: pointer;
  font-size: 1.5rem;
}

.menu-activator-icon {
  display: flex;
  align-items: center;
  justify-content: start;
  height: 100%;
  cursor: pointer;
}

.menu-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.menu-footer {
  background-color: black;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: white;
  }
}

.v-menu__content {
  max-width: 500px;
  width: 500px;
  background-color: white;
  top: 0px !important;
  height: 100vh;
}

.contact-us {
  margin-top: 1rem;
  padding: 0.625rem 0.9375rem;
  display: flex;
  flex-direction: column;
}
</style>
